const headers = {
  "Content-type": "application/json; charset=UTF-8",
  "X-CSRFToken": window.csrf,
  "Accept-Language": window.lang,
};

function generateYears(maxYears, currentYear) {
  return Array.from({ length: maxYears }, (_, index) => currentYear - index)
}

function limitLength(input, digits, isNumber = true) {
  let value = input
  if (isNumber) {
    value = value.replace(/\D/g, '');
  }
  if (value.length > digits) {
    value = value.slice(0, digits);
  }
  return value
}

function showError(message) {
  this.notice = {
      show: true,
      type: "error",
      text: message,
  };
  setTimeout(() => {
      this.notice.show = false;
  }, 5000);
}

function showSuccess(message) {
  this.notice = {
      show: true,
      type: 'success',
      text: message
  }
  setTimeout(() => {
      this.notice.show = false
  }, 5000)
}


function debounce(func, delay) {
  let timeoutId;
  return function (...args) {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => {
      func.apply(this, args);
    }, delay);
  };
}
export { showError, showSuccess, headers, generateYears, limitLength, debounce }